module.exports = __webpack_public_path__ + "img/background.8314427e.png";